import { shorthands } from '@tamagui/shorthands'
import { createTokens } from '@tamagui/web'
import { createTamagui } from 'tamagui'

import { animations } from './config/animations'
import { bodyFont, headingFont } from './config/fonts'
import { media, mediaQueryDefaultActive } from './config/media'
import * as themesIn from './themes/theme-generated'
import { color } from './themes/token-colors'
import { mogg } from './themes/token-mogg'
import { radius } from './themes/token-radius'
import { size } from './themes/token-size'
import { space } from './themes/token-space'
import { zIndex } from './themes/token-z-index'

/**
 * This avoids shipping themes as JS. Instead, Tamagui will hydrate them from CSS.
 */
const themes =
  process.env.TAMAGUI_IS_SERVER || process.env.NODE_ENV === 'development'
    ? themesIn
    : ({} as typeof themesIn)

const conf = {
  themes: themesIn,
  defaultFont: 'body',
  animations,
  shouldAddPrefersColorThemes: true,
  themeClassNameOnRoot: true,
  shorthands,
  fonts: {
    heading: headingFont,
    body: bodyFont,
  },
  tokens: createTokens({
    color,
    radius,
    zIndex,
    space,
    size,
    mogg,
  }),
  media,
} satisfies Parameters<typeof createTamagui>['0']

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - passing this directly breaks TS types
conf.mediaQueryDefaultActive = mediaQueryDefaultActive

export const config = createTamagui(conf)
